/**
 * 로케일 JSON의 HTML 엔티티(&lt;br/&gt;, &amp;amp; 등)를
 * 안전하게 렌더링하는 래퍼 컴포넌트.
 * 원본 Pug 템플릿의 `!= __('key')` 에 해당.
 */
export default function HtmlText({
  html,
  as: Tag = 'span',
  className,
  style,
}: {
  html: string;
  as?: 'span' | 'div' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  className?: string;
  style?: React.CSSProperties;
}) {
  return <Tag dangerouslySetInnerHTML={{ __html: html }} className={className} style={style} />;
}
